import axios from './axios'
import qs from 'qs';
let rankBastUrl = '/api/rankStatistics/';
/**
 *
 * 
 */
export default {
  // 获取买家前1000商品数量排行列表
  shopList(data) {
    return axios.get(rankBastUrl + 'shopList', {
      params: data
    });
  },
  // 获取品牌商品数量排行列表
  brandRankList(data) {
    return axios.get(rankBastUrl + 'brandRankList', {
      params: data
    });
  },

  // 获取品牌销售金额排行
  brandSalesAmountRankList(data) {
    return axios.get(rankBastUrl + 'brandSalesAmountRankList', {
      params: data
    });
  }
}
